/**
 * Iconos de la interfaz, en SVG inline.
 *
 * Van inline y no como fuente ni sprite externo: son pocos kilobytes, no cuestan
 * una peticion mas y heredan `currentColor`, asi que funcionan igual en tema
 * claro y oscuro sin duplicar nada.
 *
 * Son decorativos: llevan `aria-hidden`, y el significado siempre lo pone el
 * texto que va al lado o el `aria-label` del control que los contiene.
 */

const TRAZOS = {
  buscar: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>,
  carro: (
    <>
      <path d="M2.5 3h2.2l2.3 11.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.55L20.5 7H6" />
      <circle cx="9.5" cy="20" r="1.4" />
      <circle cx="17.5" cy="20" r="1.4" />
    </>
  ),
  corazon: (
    <path d="M12 20.3l-1.3-1.2C6 14.9 3 12.2 3 8.8 3 6.1 5.1 4 7.8 4c1.5 0 3 .7 3.9 1.8l.3.4.3-.4A5 5 0 0 1 16.2 4C18.9 4 21 6.1 21 8.8c0 3.4-3 6.1-7.7 10.4z" />
  ),
  cerrar: <path d="M6 6l12 12M18 6L6 18" />,
  flecha: <path d="M5 12h14M13 6l6 6-6 6" />,
  flechaIzq: <path d="M19 12H5M11 18l-6-6 6-6" />,
  chevron: <path d="M9 6l6 6-6 6" />,
  mas: <path d="M12 5v14M5 12h14" />,
  menos: <path d="M5 12h14" />,
  check: <path d="M4 12.5l5 5L20 6.5" />,
  checkCirc: <><circle cx="12" cy="12" r="9" /><path d="M8 12.4l2.6 2.6L16 9.6" /></>,
  alerta: <><path d="M12 3.2L1.8 20.8h20.4z" /><path d="M12 9.5v5M12 17.6h.01" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>,
  camion: (
    <>
      <path d="M1.5 5.5h12v11h-12z" />
      <path d="M13.5 9h4l3 3.2v4.3h-7z" />
      <circle cx="6" cy="18.5" r="1.8" />
      <circle cx="17" cy="18.5" r="1.8" />
    </>
  ),
  tienda: (
    <>
      <path d="M3.5 9.5V20h17V9.5" />
      <path d="M2.2 9.5L4 4h16l1.8 5.5a3.2 3.2 0 0 1-6.4.3 3.2 3.2 0 0 1-6.4 0 3.2 3.2 0 0 1-6.4-.3z" />
    </>
  ),
  tarjeta: <><rect x="2.2" y="5" width="19.6" height="14" rx="2.2" /><path d="M2.2 9.8h19.6" /></>,
  escudo: (
    <>
      <path d="M12 2.8l8 3v6c0 4.6-3.3 8.5-8 9.4-4.7-.9-8-4.8-8-9.4v-6z" />
      <path d="M8.8 12l2.2 2.2 4.2-4.4" />
    </>
  ),
  wa: (
    <>
      <path d="M3 21l1.6-4.6A8.4 8.4 0 1 1 8 20z" />
      <path
        d="M8.6 9.2c-.2 1.4 1.5 4.4 3.6 5.5 1 .5 1.9.7 2.4.2l.7-.8-1.9-1.2-.8.7c-.9-.4-1.9-1.4-2.3-2.4l.7-.7-1.2-1.9z"
        fill="currentColor"
        stroke="none"
      />
    </>
  ),
  caja: <><path d="M3 7.5l9-4.5 9 4.5v9L12 21l-9-4.5z" /><path d="M3 7.5l9 4.5 9-4.5M12 12v9" /></>,
  etiqueta: <><path d="M20.5 12.5l-8 8-9-9V3.5h8z" /><circle cx="8" cy="8" r="1.3" /></>,
  lista: <path d="M8.5 6h12M8.5 12h12M8.5 18h12M4 6h.01M4 12h.01M4 18h.01" />,
  sincro: (
    <>
      <path d="M20.5 12a8.5 8.5 0 0 1-14.6 6M3.5 12a8.5 8.5 0 0 1 14.6-6" />
      <path d="M18.1 2.5V6h-3.5M5.9 21.5V18h3.5" />
    </>
  ),
  grafico: <><path d="M3 20h18" /><path d="M6 20v-6M11 20V7M16 20v-9M21 20v-4" /></>,
  lupaVacia: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5M8.6 11h4.8" /></>,
  reloj: <><circle cx="12" cy="12" r="9" /><path d="M12 6.8V12l3.4 2" /></>,
  arribaDer: <path d="M7 17L17 7M8.5 7H17v8.5" />,
  rayo: <path d="M13.5 2.5L4 13.8h6.4l-.9 7.7L19 10.2h-6.4z" />,
  menu: <path d="M3.5 6.5h17M3.5 12h17M3.5 17.5h17" />,
  pausa: <path d="M8 5.5v13M16 5.5v13" strokeWidth="2.6" />,
  reproducir: <path d="M7.5 5l11 7-11 7z" fill="currentColor" />,
  sol: (
    <>
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 1.8v2.4M12 19.8v2.4M4.6 4.6l1.7 1.7M17.7 17.7l1.7 1.7M1.8 12h2.4M19.8 12h2.4M4.6 19.4l1.7-1.7M17.7 6.3l1.7-1.7" />
    </>
  ),
  luna: <path d="M20.5 14.3A8.6 8.6 0 0 1 9.7 3.5a8.6 8.6 0 1 0 10.8 10.8z" />,
  factura: <><path d="M5 3.5h14v17l-3-2-2 2-2-2-2 2-2-2-3 2z" /><path d="M9 8.5h6M9 12.5h6" /></>,
  instagram: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
  facebook: (
    <path
      d="M14.5 8.5h2.5V5h-2.5a4 4 0 0 0-4 4v2H8v3.5h2.5V21H14v-6.5h2.5L17 11h-3V9.5a1 1 0 0 1 .5-1z"
      fill="currentColor"
      stroke="none"
    />
  ),
  panel: (
    <>
      <rect x="3" y="3" width="7.5" height="8.5" rx="1.4" />
      <rect x="13.5" y="3" width="7.5" height="5.5" rx="1.4" />
      <rect x="3" y="14.5" width="7.5" height="6.5" rx="1.4" />
      <rect x="13.5" y="11.5" width="7.5" height="9.5" rx="1.4" />
    </>
  ),
  ojo: <><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" /><circle cx="12" cy="12" r="2.6" /></>,
  ojoNo: (
    <>
      <path d="M9.9 5.8A9.9 9.9 0 0 1 12 5.5c6.4 0 10 6.5 10 6.5a17 17 0 0 1-3.4 4.2M6.4 7.8A16.6 16.6 0 0 0 2 12s3.6 6.5 10 6.5c1.5 0 2.8-.3 4-.8" />
      <path d="M3 3l18 18" />
    </>
  ),
  persona: <><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" /></>,
  correo: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 6.5l8.5 6.5 8.5-6.5" /></>,
  personas: (
    <>
      <circle cx="9" cy="8" r="3.6" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16.5 5.2a3.6 3.6 0 0 1 0 6.9M18 14.4a6.5 6.5 0 0 1 3.5 5.6" />
    </>
  ),
  salir: <path d="M15 8.5V5.5a1.5 1.5 0 0 0-1.5-1.5H5.5A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20h8a1.5 1.5 0 0 0 1.5-1.5v-3M10 12h11M17.5 8.5L21 12l-3.5 3.5" />,
  llave: (
    <>
      <circle cx="7.5" cy="14.5" r="4" />
      <path d="M10.4 11.6L20 2m-3 3l2.4 2.4M14.6 7.4l2.4 2.4" />
    </>
  ),
  camara: (
    <>
      <path d="M3.2 8.4h3.4l1.6-2.4h7.6l1.6 2.4h3.4v10.4H3.2z" />
      <circle cx="12" cy="13.4" r="3.6" />
    </>
  ),
  galeria: (
    <>
      <rect x="3" y="4.6" width="18" height="14.8" rx="2" />
      <path d="M3 16.2l4.8-4.6 3.4 3.2 3.6-4L21 16.6" />
      <circle cx="8.4" cy="9" r="1.4" />
    </>
  ),
  copiar: (
    <>
      <rect x="8.5" y="8.5" width="12" height="12" rx="2.2" />
      <path d="M15.5 8.5V5.7A2.2 2.2 0 0 0 13.3 3.5H5.7a2.2 2.2 0 0 0-2.2 2.2v7.6a2.2 2.2 0 0 0 2.2 2.2h2.8" />
    </>
  ),
  telefono: (
    <path d="M21.5 16.6v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.6 3.9 2 2 0 0 1 3.6 1.7h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7.6 9.6a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
  ),
  ubicacion: (
    <>
      <path d="M12 21.2s-7-6.2-7-11.6a7 7 0 0 1 14 0c0 5.4-7 11.6-7 11.6z" />
      <circle cx="12" cy="9.6" r="2.6" />
    </>
  ),
  estacionamiento: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M9.5 17V7h3.4a3 3 0 0 1 0 6H9.5" />
    </>
  ),
  herramienta: (
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9z" />
  ),
  disco: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="2.4" />
      <path d="M12 3v3M21 12h-3M12 21v-3M3 12h3M18.4 5.6l-2.1 2.1M18.4 18.4l-2.1-2.1M5.6 18.4l2.1-2.1M5.6 5.6l2.1 2.1" />
    </>
  ),
  broca: (
    <>
      <path d="M10 2.5h4v5h-4z" />
      <path d="M10 7.5h4l-.5 9-1.5 5-1.5-5z" />
      <path d="M10.3 10.5l3.4 1.6M10.6 13.6l2.8 1.4" />
    </>
  ),
  brillo: (
    <>
      <path d="M11 3l1.8 5.2L18 10l-5.2 1.8L11 17l-1.8-5.2L4 10l5.2-1.8z" />
      <path d="M18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
    </>
  ),
} as const;

export type NombreIcono = keyof typeof TRAZOS;

export interface IconoProps {
  nombre: NombreIcono;
  className?: string;
}

export function Icono({ nombre, className }: IconoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...(className !== undefined ? { className } : {})}
    >
      {TRAZOS[nombre]}
    </svg>
  );
}
